import React from 'react'
import styled from 'styled-components'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

const Logo = () => {
  const { logoImage } = useStaticQuery(graphql`
    {
      logoImage: file(relativePath: { eq: "logo-tag.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 244, quality: 100, placeholder: NONE)
        }
      }
    }
  `)
  return (
    <Container>
      <StyledLink to='/'>
        <GatsbyImage
          image={logoImage.childImageSharp.gatsbyImageData}
          loading='eager'
          alt='Hutson Inc'
        />
      </StyledLink>
    </Container>
  )
}

const Container = styled.div`
  height: auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 200px;
  z-index: 1;

  @media (min-width: 900px) {
    width: 244px;
  }
`

const StyledLink = styled(Link)`
  display: block;
  height: 100%;
  width: 100%;
`

export default Logo
